import Typography from "@mui/material/Typography";

import { NewsDto, useParseHtmlContent } from "../../..";

import "../../../../../../../components/RichTextField/styles/customReactQuillNewStyle.css";

import { colors } from "@dotnet/telematics-design-system";

interface ReleaseNotesDetailsProps {
  note: NewsDto;
}

const ReleaseNotesDetails = ({ note }: ReleaseNotesDetailsProps) => {
  const { parseContent } = useParseHtmlContent();

  const notesWithSpaces = note.content
    .replaceAll("&nbsp;", " ")
    .replaceAll("<p></p>", "<p><br/></p>");

  return (
    <>
      <Typography
        variant="body2Medium"
        sx={{ color: colors.textSecondary }}
        component="div"
      >
        {note.title}:
      </Typography>
      <Typography
        variant="body2Medium"
        component="div"
        className="ql-editor"
        sx={{
          'li[data-list="bullet"]': { listStyleType: "disc" },
          li: {
            listStyleType: "inherit"
          },
          ul: {
            paddingLeft: "1.5em"
          }
        }}
      >
        {parseContent(notesWithSpaces)}
      </Typography>
    </>
  );
};

export default ReleaseNotesDetails;
